import { CanActivateFn, Router } from '@angular/router'
import { inject } from '@angular/core'
import { ApiService } from '../services/api.service'
import { map, take } from 'rxjs'

export const claimsAccessGuard: CanActivateFn = () => {
    const api = inject(ApiService)
    const router = inject(Router)

    return api.userInfo.pipe(
        take(1),
        map(userInfo => {
            if (userInfo?.authorities?.includes('canAccessClaims')) {
                return true
            }
            return router.parseUrl('/home')
        })
    )
}
